import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {filter, map, switchMap} from 'rxjs/operators';
import {UserService} from "../../user/user.service";
import * as userLocalStorageActions from "../actions/user-local-storage.action";
import {DbResponse} from "../../shared/interceptors/db-response";
import {TypeUtils} from "../../shared/utils/type-utils";
import {EMPTY} from "rxjs";

@Injectable()
export class UserLocalStorageEffect {


  loadUserLocalStorage$ = createEffect(() => this._actions$.pipe(
    ofType(userLocalStorageActions.LOAD_USER_LOCAL_STORAGE),
    switchMap(() => {
      if (!localStorage.getItem('dbUserAccessToken')) {
        return EMPTY;
      }
      return this._userService.getFromLocal()
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              const data = response.data && TypeUtils.isDefined(response.data.data) ? response.data.data : response.data;
              return new userLocalStorageActions.LoadUserLocalStorageSuccess(data);
            }

            return new userLocalStorageActions.LoadUserLocalStorageFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _userService: UserService,
  ) {
  }

}
